module.exports = __webpack_public_path__ + "img/red-card.cdfd97b9.svg";